// extracted by mini-css-extract-plugin
module.exports = {"left":"Persona_left__uQr6Y","slideInLeft":"Persona_slideInLeft__2I841","right":"Persona_right__LiB26","slideInRight":"Persona_slideInRight__1bFg5"};